var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.77899 5.92198L5.77846 5.92145C5.75693 5.89992 5.74365 5.86918 5.74365 5.83333C5.74365 5.79748 5.75693 5.76675 5.77846 5.74522C5.79998 5.72369 5.83072 5.71042 5.86657 5.71042C5.90233 5.71042 5.933 5.72363 5.95452 5.74506C5.95457 5.74511 5.95463 5.74517 5.95468 5.74522L14.2542 14.0697L14.2547 14.0702C14.2762 14.0917 14.2895 14.1225 14.2895 14.1583C14.2895 14.1942 14.2762 14.2249 14.2547 14.2464C14.24 14.2611 14.226 14.2696 14.2131 14.2747C14.1998 14.2801 14.1843 14.2833 14.1666 14.2833C14.1489 14.2833 14.1334 14.2801 14.12 14.2747C14.1072 14.2696 14.0932 14.2612 14.0786 14.2466C14.0786 14.2465 14.0785 14.2465 14.0785 14.2464L5.77899 5.92198L5.77899 5.92198Z",
    fill: "black",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83337 14.7833C5.67503 14.7833 5.5167 14.725 5.3917 14.6C5.15003 14.3583 5.15003 13.9583 5.3917 13.7167L13.6917 5.39167C13.9334 5.15 14.3334 5.15 14.575 5.39167C14.8167 5.63333 14.8167 6.03333 14.575 6.275L6.27503 14.6C6.15003 14.725 5.9917 14.7833 5.83337 14.7833Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchXIcon);
export default __webpack_public_path__ + "static/media/SearchXIcon.218376e3ec9350da5fc026c659e4f78a.svg";
export { ForwardRef as ReactComponent };